'use client'

import { SoloViewerTokenFragment } from '@/gql/generated/graphql'
import { TokenGridItem } from '@components/token-grid-item'

type UserTokenGridItemProps = {
  token: SoloViewerTokenFragment
  showDetails?: boolean
}

export const UserTokenGridItem = ({ token, showDetails = true }: UserTokenGridItemProps): React.ReactElement => {
  return (
    <div className="[&_.p-md]:!p-sm">
      <TokenGridItem token={token} hideNavigationArrows={true} hideDetails={!showDetails} />
    </div>
  )
}
